import React from "react";
import { observer } from "mobx-react-lite";
import { StudentBehaviourView } from "Views/Shared/Views/StudentBehaviour/StudentBehaviourView";
import { StudentBehaviourViewModel } from "Views/Shared/Views/StudentBehaviour/StudentBehaviourViewModel";
import { Box, Label, Show, theme } from "Application";

export const StudentBehavioursView: React.FC<{ showStudentBehaviours: boolean; viewModels: StudentBehaviourViewModel[] }> = observer(({ showStudentBehaviours, viewModels }) => {
    return (
        <Box flexBox gap="20px" flexDirection={"column"}>
            <Label fontStyle="h2">Targeted Intervention Behaviours</Label>

            <Show if={!showStudentBehaviours}>
                <Label fontStyle="p">The student is not receiving targeted intervention</Label>
            </Show>

            <Show if={showStudentBehaviours}>
                <Box flexBox flexWrap={"wrap"} gap="10px">
                    {viewModels.map((vm) => (
                        <StudentBehaviourView key={vm.model.KEY} viewModel={vm} />
                    ))}
                </Box>
            </Show>
        </Box>
    );
});
